import React from 'react'

export function Columns() {
  return (
    <div className="grid grid-cols-3 font-purple-500 font-extrabold text-2xl pt-4 -mb-2 justify-items-center">
      <div>Team</div>
      <div>Hackers</div>
      <div>Prize</div>
    </div>
  )
}
